import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5457_9830)">
      <g clip-path="url(#clip1_5457_9830)">
        <path
          d="M0.979348 5.19995H11.4856C11.6757 5.19995 11.8296 5.35027 11.8296 5.53592V10.3438C11.8296 10.644 11.6505 10.9164 11.3715 11.0412L10.0482 11.6345C9.98357 11.6635 9.94191 11.7266 9.94191 11.7964C9.94191 11.8653 9.98222 11.9275 10.0459 11.957L11.3812 12.5771C11.6551 12.7041 11.8296 12.9739 11.8296 13.2705V18.4635C11.8296 18.6492 11.6757 18.7995 11.4856 18.7995H0.979348C0.43837 18.7995 0 18.3714 0 17.843V6.15643C0 5.62808 0.43837 5.19995 0.979348 5.19995ZM6.67772 14.2663C6.94566 14.2663 7.13668 14.231 7.25028 14.1608C7.37397 14.09 7.43582 13.9594 7.43582 13.768V13.7376C7.43582 13.5362 7.36892 13.3948 7.23471 13.3143C7.11102 13.2338 6.89945 13.1936 6.60031 13.1936H4.6416V14.2663H6.67772ZM6.58517 10.5943C7.05975 10.5943 7.29705 10.4279 7.29705 10.0955V10.0199C7.29705 9.82842 7.2352 9.69735 7.11151 9.62711C6.99791 9.54658 6.80732 9.50632 6.53889 9.50632H4.64206V10.5943H6.58566H6.58517ZM12.7201 13.1483H17.0497C17.0497 13.491 17.1116 13.7277 17.2353 13.8588C17.3695 13.9899 17.56 14.0552 17.8078 14.0552C18.2306 14.0552 18.4423 13.8185 18.4423 13.3448C18.4423 13.113 18.3699 12.947 18.2256 12.8459C18.0914 12.7452 17.8852 12.6947 17.6068 12.6947H15.2239V10.9419L18.8907 10.0503H12.7201C12.5479 10.0503 12.4081 9.91387 12.4081 9.74566V5.4545C12.4081 5.31403 12.5249 5.19995 12.6688 5.19995H22.8196C23.3606 5.19995 23.7989 5.62808 23.7989 6.15643V9.58595C23.7989 9.97337 23.5263 10.3102 23.1407 10.4002L19.123 11.3352L19.3085 11.3656H23.143C23.6161 11.3656 24 11.7405 24 12.2026V17.8435C24 18.3718 23.5616 18.8 23.0207 18.8H12.6688C12.5249 18.8 12.4081 18.6859 12.4081 18.5454V13.453C12.4081 13.2848 12.5479 13.1483 12.7201 13.1483Z"
          fill="#3368EF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5457_9830">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_5457_9830">
        <rect
          width="24"
          height="13.6"
          fill="white"
          transform="translate(0 5.19995)"
        />
      </clipPath>
    </defs>
  </svg>
)
